import { getItem, removeItem, setItem } from "../helpers/localStorage";

export const INSPECT_TOKENS_KEY = "inspect_tokens";

export interface InspectTokenEntry {
    /** Exchange access token for the inspected account. */
    token: string;
    /** Token expiry in seconds since epoch (decoded from the JWT). */
    exp: number;
    /** The partner account id that minted the token. */
    partnerId: string;
}

type InspectTokenMap = { [accountId: string]: InspectTokenEntry };

export const getInspectTokens = (): InspectTokenMap => {
    try {
        const raw = getItem(INSPECT_TOKENS_KEY);
        if (!raw) {
            return {};
        }
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
        return {};
    }
};

export const getInspectToken = (
    accountId: string,
): InspectTokenEntry | undefined => getInspectTokens()[accountId];

export const setInspectToken = (
    accountId: string,
    entry: InspectTokenEntry,
): void => {
    const map = getInspectTokens();
    map[accountId] = entry;
    setItem(INSPECT_TOKENS_KEY, JSON.stringify(map));
};

export const removeInspectToken = (accountId: string): void => {
    const map = getInspectTokens();
    if (accountId in map) {
        delete map[accountId];
        setItem(INSPECT_TOKENS_KEY, JSON.stringify(map));
    }
};

export const clearInspectTokens = (): void => {
    removeItem(INSPECT_TOKENS_KEY);
};
